export const getStationDetails = ({ station, stations, includeCity = false }) => {
  const stationDetail = stations.find((st) => st.uic === station);
  return {
    city: stationDetail.name,
    uic: station,
    iso: stationDetail.countryCode,
    ...(includeCity && { shortName: stationDetail.city })
  };
};

export const buildContent = ({ contentsChildren = [] }) => contentsChildren.map((contentChildren) => contentChildren.text) || [];
export const buildExpendable = ({ expendablesChildren = {} }) => {
  if (expendablesChildren.primaryBody?.length > 0) {
    const expendableSection = expendablesChildren.primaryBody?.map((body) => body.children?.map((c) => c.text)) || [];
    return expendableSection.filter(Boolean);
  }

  return [];
};

export const buildBorderData = (borderData) => ({
  outbound: {
    ees: {
      title: borderData?.outbound?.ees?.requirements?.[0]?.subTitle,
      content: buildContent({ contentsChildren: borderData?.outbound?.ees?.requirements?.[0]?.title?.[0]?.children }),
      expendable: buildExpendable({ expendablesChildren: borderData?.outbound?.ees?.requirements?.[0] })
    },
    visaOrTravelAuth: {
      title: borderData?.outbound?.visaOrTravelAuth?.requirements?.[0]?.subTitle,
      content: buildContent({ contentsChildren: borderData?.outbound?.visaOrTravelAuth?.requirements?.[0]?.title?.[0]?.children }),
      expendable: buildExpendable({ expendablesChildren: borderData?.outbound?.visaOrTravelAuth?.requirements?.[0] })
    }
  },
  ...(borderData.inbound && {
    inbound: {
      ees: {
        title: borderData.inbound?.ees?.requirements?.[0]?.subTitle,
        content: buildContent({ contentsChildren: borderData.inbound?.ees?.requirements?.[0]?.title?.[0]?.children }),
        expendable: buildExpendable({ expendablesChildren: borderData.inbound?.ees?.requirements?.[0] })
      },
      visaOrTravelAuth: {
        title: borderData.inbound?.visaOrTravelAuth?.requirements?.[0]?.subTitle,
        content: buildContent({ contentsChildren: borderData.inbound?.visaOrTravelAuth?.requirements?.[0]?.title?.[0]?.children }),
        expendable: buildExpendable({ expendablesChildren: borderData.inbound?.visaOrTravelAuth?.requirements?.[0] })
      }
    }
  })
});
